import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, of } from 'rxjs';
import { MaintenancePopUpComponent } from './maintenance-pop-up/maintenance-pop-up.component';

@Component({
  selector: 'lib-home365-chat-input',
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'lib-home365-chat-input',
  },
})
export class ChatInputComponent implements OnInit, OnChanges {
  isCheckIn$ = new BehaviorSubject<boolean>(false);
  isCheckOutStatus$ = new BehaviorSubject<boolean>(true);
  newNoteControl = new FormControl();
  isDisabled = false;
  locationAddress?: GeolocationCoordinates;
  @Input() label = 'Type a message...';
  @Input() project?: any;
  @Input() set disable(value: boolean) {
    this.isDisabled = value;
    this._enableDisable();
  }
  @Input() isOuterUser: boolean | undefined;

  @Output() save: EventEmitter<string> = new EventEmitter<string>();
  @Output() checkStatus: EventEmitter<{ status: boolean; address: string }> = new EventEmitter<{
    status: boolean;
    address: string;
  }>();

  constructor(private dialog: MatDialog) {
    navigator.geolocation.getCurrentPosition((success: GeolocationPosition) => {
      this.locationAddress = success.coords;
    });
  }

  saveMessage(event: KeyboardEvent | MouseEvent) {
    if (this.isDisabled || !this.newNoteControl.value || !event) {
      return;
    }
    this.newNoteControl.setValue(this.newNoteControl.value.trim());
    this.save.emit(this.newNoteControl.value);
  }
  ngOnInit() {
    if (!this.project?.checkInDateTime) {
      this.isCheckIn$.next(true);
    } else {
      this.isCheckIn$.next(false);
    }

    of(this.project).subscribe(res => console.log(res));
  }
  ngOnChanges() {
    const inProgress = this.project?.statusView.status === 'in-progress';

    if ((this.project?.checkOutDateTime && this.project?.checkInDateTime) || !inProgress) {
      this.isCheckOutStatus$.next(false);
    }
  }
  filterEnter(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      this.saveMessage(event);
    }
  }

  clear() {
    this.newNoteControl.reset();
  }

  private _enableDisable() {
    if (this.isDisabled) {
      this.newNoteControl.disable();
    } else {
      this.newNoteControl.enable();
    }
  }

  checkInPopupComponent() {
    let addressExists = false;
    this.locationAddress ? addressExists = true : addressExists = false;
    const dialogRef = this.dialog.open(MaintenancePopUpComponent, {
      panelClass: 'popup-maintenance',

      data: {
        isCheckIn: false,
        address: { lat: this.locationAddress?.latitude, lng: this.locationAddress?.longitude },
        addressExists: addressExists
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isCheckIn$.next(false);
        this.checkStatus.emit({ status: true, address: result.address });
      }
    });
  }

  checkOutPopupComponent(): void {
    let addressExists = false;
    this.locationAddress ? addressExists = true : addressExists = false;
    const dialogRef = this.dialog.open(MaintenancePopUpComponent, {
      panelClass: 'popup-maintenance',
      data: {
        isCheckIn: true,
        address: { lat: this.locationAddress?.latitude, lng: this.locationAddress?.longitude },
        addressExists: addressExists
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.status === false) {
        this.isCheckIn$.next(true);
        this.isCheckOutStatus$.next(result.status);
        this.checkStatus.emit({ status: result.status, address: result.address });
      }
    });
  }
}
